/*
 ** vue router: 136
 */
import type { RouteRecordRaw } from 'vue-router';

const vrt136: RouteRecordRaw = {
  path: '/eservices/136',
  name: 'vrt136',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'create',
      name: 'vrt136Create',
      component: () => import('./vpg136Create.vue'),
    },
    {
      path: 'read',
      name: 'vrt136Read',
      component: () => import('./vpg136Read.vue'),
    },
  ],
};

export default vrt136;
